module.exports = __webpack_public_path__ + "static/media/candidateHover.e2aa50bb.svg";